import { useMemo } from 'react'
import { APPLICATION_SETTINGS } from '../../common/constants'
import { mapInputs } from '../../common/forms/general/inputs'
import { mapValidation } from '../../common/forms/general/validations'
import { realEstateMaterials3DVideoInputs } from '../../common/forms/generalRealEstate/inputs'
import { realEstateMaterials3DVideoValidation } from '../../common/forms/generalRealEstate/validations'

const useMapFormConfig = (data) => {
    const inputs = mapInputs()
    const mapValidationConfig = useMemo(() => mapValidation(data), [data])

    return {
        mapInputs: inputs,
        mapValidationConfig,
    }
}

const useRealEstateMaterials3DVideoFormConfig = (data) => {
    const appSettings = {
        currency: APPLICATION_SETTINGS.CURRENCY,
        lang: APPLICATION_SETTINGS.DEFAULT_LANGUAGE,
        areaUnit: APPLICATION_SETTINGS.AREA_UNIT,
    }

    return {
        materials3DVideoInputs: realEstateMaterials3DVideoInputs(appSettings),
        materials3DVideoValidationConfig: realEstateMaterials3DVideoValidation(data),
    }
}

export { useMapFormConfig, useRealEstateMaterials3DVideoFormConfig }
